import React from 'react';
import './Footer.css';

// Contact and social info
const contactInfo = {
  email: 'servicertc42@gmail.com',
};

const socialLinks = [
  {
    name: 'Facebook',
    url: 'https://www.facebook.com/profile.php?id=100063748172809',
    icon: 'facebook',
  },
  {
    name: 'Instagram',
    url: 'https://www.instagram.com/rollingthundercycles/',
    icon: 'instagram',
  },
];

const navLinks = [
  { name: 'Home', url: '/' },
  // Group 2: Shop
  { name: 'Certificates', url: '/certificates' },
  // Group 4: About/Contact
  { name: 'Memories', url: '/memories' },
  { name: 'Tech Tips', url: '/techtips' },
  { name: 'About', url: '/about' },
];

const MotorcycleIcon = () => (
  <span
    role="img"
    aria-label="motorcycle"
    style={{ fontSize: '1.5em', marginRight: 8 }}
  >
    🏍️
  </span>
);

const Footer = () => (
  <footer className="rtc-footer">
    <div
      style={{
        maxWidth: 1200,
        margin: '0 auto',
        padding: '3rem 1rem 1rem 1rem',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        gap: '2rem',
      }}
    >
      {/* Logo & Tagline */}
      <div style={{ flex: '1 1 220px', minWidth: 200 }}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
          <MotorcycleIcon />
          <span
            style={{ fontWeight: 'bold', fontSize: '1.3em', letterSpacing: 1 }}
          >
            Rolling Thunder Cycles
          </span>
        </div>
        <div style={{ color: '#bbb', fontSize: '1em', marginTop: 8 }}>
          Was your destination for Harley-Davidson® motorcycles, parts, and service from 1981-2025.
        </div>
      </div>

      {/* Navigation */}
      <nav style={{ flex: '2 1 320px', minWidth: 200 }}>
        <div style={{ fontWeight: 600, marginBottom: 12, fontSize: '1.1em' }}>
          Quick Links
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '2.5rem' }}>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            {/* All Links */}
            {navLinks.slice(1).map((link) => (
              <li key={link.name} style={{ marginBottom: 8 }}>
                <a
                  href={link.url}
                  style={{
                    color: '#fff',
                    textDecoration: 'none',
                    transition: 'color 0.2s',
                  }}
                  onMouseOver={(e) => (e.currentTarget.style.color = '#1f8dff')}
                  onMouseOut={(e) => (e.currentTarget.style.color = '#fff')}
                >
                  {link.name}
                </a>
              </li>
            ))}
          </ul>
      
        </div>
      </nav>

      {/* Contact Info */}
      <div style={{ flex: '1 1 220px', minWidth: 200 }}>
        <div style={{ fontWeight: 600, marginBottom: 12, fontSize: '1.1em' }}>
          Contact
        </div>
        <div style={{ marginBottom: 8 }}>
          <span role="img" aria-label="email">
            ✉️
          </span>
          <a
            href={`mailto:${contactInfo.email}`}
            style={{ color: '#fff', textDecoration: 'none' }}
          >
            {contactInfo.email}
          </a>
        </div>
        <div style={{ marginBottom: 8 }}>
          <span role="img" aria-label="phone-number">
            📞
          </span>
          <a href="/recommended-techs">For service</a>: contact our tech Peter at <a href="tel:516-426-2254" style={{ color: '#fff', textDecoration: 'none' }}>
            516-426-2254
          </a>  
        </div>
      </div>

      {/* Social */}
      <div style={{ flex: '1 1 120px', minWidth: 100 }}>
        <div style={{ fontWeight: 600, marginBottom: 12, fontSize: '1.1em' }}>
          Follow Us
        </div>
        <div>
          {socialLinks.map((link) => (
            <a
              key={link.name}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'inline-block',
                marginRight: 12,
                verticalAlign: 'middle',
                transition: 'transform 0.2s',
                color: '#fff',
              }}
              aria-label={link.name}
              onMouseOver={(e) =>
                (e.currentTarget.style.transform = 'scale(1.15)')
              }
              onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
            >
              {link.icon === 'facebook' && (
                <i className="fab fa-facebook fa-lg"></i>
              )}
              {link.icon === 'instagram' && (
                <i className="fab fa-instagram fa-lg"></i>
              )}
            </a>
          ))}
        </div>
      </div>
    </div>
    {/* Bottom Bar */}
    <div
      style={{
        borderTop: '1px solid #333',
        marginTop: '2rem',
        padding: '1rem 1rem 0.5rem 1rem',
        textAlign: 'center',
        color: '#bbb',
        fontSize: '0.95em',
        letterSpacing: 0.2,
      }}
    >
      &copy; {new Date().getFullYear()} Rolling Thunder Cycles. All rights
      reserved.
    </div>
  </footer>
);

export default Footer;
